import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {adminLocaleSelector} from 'src/modules/main/services/user-info-slice';
import {DecimalFormat} from 'src/openapi/admin/models/DecimalFormat';
import {ThousandFormat} from 'src/openapi/admin/models/ThousandFormat';

import {LocaleContext} from '@pb/kit-context-locale';

import type {Locale} from '@pb/kit-context-locale';


type Props = {
    children: React.ReactNode,
};

const DEFAULT_LOCALE: Locale = {
    currency: 'USD',
    dateFormat: 'MMDDYYYY',
    decimalFormat: DecimalFormat.PERIOD,
    thousandFormat: ThousandFormat.COMMA,
    paperFormat: 'LETTER',
    symbolPosition: 'RIGHT',
    nativeCurrency: true,
};

export const LocaleContextProvider = ({children}: Props) => {
    const adminLocale = useSelector(adminLocaleSelector);

    const value = useMemo(() => ({locale: adminLocale || DEFAULT_LOCALE}), [adminLocale]);

    return (
        <LocaleContext.Provider value={value}>
            {children}
        </LocaleContext.Provider>
    );
};
